module.exports = __webpack_public_path__ + "media/newstyle/images/icon-tu-libro-4ed3d7e099aa24423a807d167629d24c.png";